import React from 'react';
import Icon from '../../../components/AppIcon';

const features = [
  { icon: 'FileCheck', label: 'Apply for Card', description: 'Submit your application when the card launches.' },
  { icon: 'ClipboardList', label: 'Card Approval Status', description: 'Track your application through the review process.' },
  { icon: 'Eye', label: 'View Card Details', description: 'Access your card number, CVV, and limits securely.' },
  { icon: 'Receipt', label: 'Transaction History', description: 'Full history of purchases and cashback earned.' },
  { icon: 'Snowflake', label: 'Freeze Card', description: 'Instantly lock your card if it is lost or stolen.' }
];

const FutureFeatures = () => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold text-foreground">Coming Features</h2>
          <p className="text-muted-foreground text-sm mt-1">Full card management — launching with the card</p>
        </div>
        <span
          className="px-3 py-1 rounded-full text-xs font-semibold"
          style={{ background: 'rgba(245, 158, 11, 0.1)', color: '#F59E0B', border: '1px solid rgba(245, 158, 11, 0.2)' }}
        >
          Roadmap
        </span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">
        {features?.map((feature, i) => (
          <div
            key={i}
            className="relative rounded-2xl p-4 group cursor-not-allowed"
            style={{
              background: 'rgba(15, 23, 42, 0.6)',
              border: '1px solid rgba(51, 65, 85, 0.5)'
            }}
          >
            {/* Lock overlay */}
            <div className="absolute top-3 right-3">
              <Icon name="Lock" size={12} className="text-muted-foreground opacity-50" />
            </div>

            <div
              className="w-9 h-9 rounded-xl flex items-center justify-center mb-3 opacity-40"
              style={{ background: 'rgba(51, 65, 85, 0.8)' }}
            >
              <Icon name={feature?.icon} size={16} className="text-muted-foreground" />
            </div>

            <p className="text-sm font-medium text-muted-foreground mb-1 opacity-60">{feature?.label}</p>
            <p className="text-xs text-muted-foreground opacity-40 leading-snug">{feature?.description}</p>

            <div
              className="mt-3 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs"
              style={{ background: 'rgba(245, 158, 11, 0.08)', color: 'rgba(245, 158, 11, 0.6)', border: '1px solid rgba(245, 158, 11, 0.15)' }}
            >
              <Icon name="Clock" size={10} />
              Coming Soon
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FutureFeatures;
